import React, { useEffect, useReducer, useState } from 'react';

import { Row, Col, Typography, Space, Table, Empty, Spin, message, Modal, Button, Form, Input, Popover, Avatar, Card, Switch, Select} from 'antd';
import { Content } from 'antd/es/layout/layout';

import { DeleteOutlined, EditOutlined, InfoOutlined, PlusOutlined, ProductOutlined } from '@ant-design/icons';
import axios from 'axios';

import modelReducer from './reducer';
import {  ADD_MODEL_CLASSIFICATION, ADD_MODEL_CLASSIFICATION_ERROR, ADD_MODEL_CLASSIFICATION_SUCCESS, DELETE_MODEL_CLASSIFICATION, DELETE_MODEL_CLASSIFICATION_ERROR, DELETE_MODEL_CLASSIFICATION_SUCCESS, EDIT_MODEL_CLASSIFICATION, EDIT_MODEL_CLASSIFICATION_ERROR, EDIT_MODEL_CLASSIFICATION_SUCCESS, MODEL_CLASSIFICATION_DETAILS, MODEL_CLASSIFICATION_DETAILS_ERROR, MODEL_CLASSIFICATION_DETAILS_SUCCESS, MODEL_CLASSIFICATIONS, MODEL_CLASSIFICATIONS_ERROR, MODEL_CLASSIFICATIONS_SUCCESS, PREDICTION_LEVEL_LIST, PREDICTION_LEVEL_LIST_ERROR, PREDICTION_LEVEL_LIST_SUCCESS } from './constants';
import { useNavigate } from 'react-router-dom';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import TextArea from 'antd/es/input/TextArea';

const { Title } = Typography;


export default function ModelClassificationConfig() {

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const initalState = { loading: false, error: false, modelClassificationDate : [], details : [], predictionlevel : []};
	const [data, dispatch] = useReducer(modelReducer, initalState);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
    
	const navigate = useNavigate();
	
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	// const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const [form] = Form.useForm();	
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));


	useEffect(() => {
		if(featuresModule.modelclassificationsEnabled == false) {
			navigate('/dashboard');
		}
			
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4024);
	}, []);
    
	useEffect(() => {

		if(!authtoken){
			navigate('/');
		}

		loadModelClassification();

	},[authtoken]);

	const predictionlevels = [];
	// eslint-disable-next-line array-callback-return
	data?.predictionlevel && data?.predictionlevel.map((item)=> {
		predictionlevels.push({
			value:item.id,
			label:item.name
		});
	});


	const loadModelClassification = ()=>{
		dispatch({ type : MODEL_CLASSIFICATIONS });

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications/?$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization':  `Bearer ${authtoken}`
			},
		};
    
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : MODEL_CLASSIFICATIONS_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  'It seems the network is unreachable. Please refresh the application.',
					});
				}
				dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
			});
	};



	const loadpredicitonlevel= ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/predictionlevel/?&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : PREDICTION_LEVEL_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
									
					dispatch({ type : PREDICTION_LEVEL_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : PREDICTION_LEVEL_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : PREDICTION_LEVEL_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const submodeltoggle = (value,record)=>{
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications/${record.id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				'isSubmodel' : value
						
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					Modal.success({ title: `${langdata && langdata.submodelEnableStatusUpdatedSuccessfully ? langdata.submodelEnableStatusUpdatedSuccessfully :'Submodel Status Updated Successfully'}` });
					loadModelClassification();
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
		
	};

	const columns = [
		{
			title : 'Name',
			dataIndex : 'alias',
			key : 'alias'
		},
		{
			title: 'Model Level',
			dataIndex: 'modelLevel',
			key: 'modelLevel'
		},
		{
			title: 'Parent Model Level',
			dataIndex: 'parentmodelLevel',
			key: 'parentmodelLevel',
		},

		{
			title:  langdata && langdata.Description ? langdata.Description : 'Description',
			dataIndex: 'description',
			key: 'description',
			render: (text) => (
				<Popover overlayStyle={{ width : text.length >= 80 ?  '80%' : '' }}  title={langdata && langdata.Description ? langdata.Description :'Description'} content={text} trigger="hover">
					<Typography
					>
						{ text.length >= 80 ? text.slice(0,80) + '...' : text.slice(0,80)}
					</Typography>
				</Popover>
			)

		},
		{
			title: `${langdata && langdata.loaderType ? langdata.loaderType : 'Loader Type'}`,
			dataIndex: 'loaderType',
			key: 'loaderType',
		},
		{
			title: `${langdata && langdata.PredictionLevel ? langdata.PredictionLevel : 'Prediction Level'}`,
			dataIndex: 'predictlvlname',
			key: 'predictlvlname',
		},
		{
			title:langdata&&langdata.submodel?langdata.submodel:'Sub Model',
			dataIndex: 'isSubmodel',
			key: 'isSubmodel',
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => submodeltoggle(value,record)} />
				</>
			),
					
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: (record) => (
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>showEditDrawer(record)}><EditOutlined/></a>
						{/* <a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={()=>openDeleteClassificationModal(record)}><DeleteOutlined/></a> */}
					</Space>
				</>
			)
		},

	];


	const showEditDrawer = (record) => {
		loadModelClassificationDetails(record);
		setOpenEditDrawer(true);
		loadpredicitonlevel();
		
	};

	// const openDeleteClassificationModal = (record) => {
	// 	loadModelClassificationDetails(record);
	// 	setShowDeleteModal(true);  
	// };

	const deleteModelClassification = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_MODEL_CLASSIFICATION });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_MODEL_CLASSIFICATION_SUCCESS, payload: response});
					setShowDeleteModal(false);        
					loadModelClassification();
				} else {
					dispatch({type:DELETE_MODEL_CLASSIFICATION_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_MODEL_CLASSIFICATION_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteBatchModal = () => {
		setShowDeleteModal(false);
	};
	const editModelClassification = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.alias || '',
			description: data?.details?.description || '',
			loaderType : data?.details?.loaderType || '',
			predictionlevelId : data?.details?.predictionlevelId || null

			
		},
		onSubmit: (values) => {
	
		
			dispatch({type:EDIT_MODEL_CLASSIFICATION});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/modelclassifications/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					alias : values.name,
					description : values.description,
					loaderType : values.loaderType,
					predictionlevelId : values.predictionlevelId
					
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_MODEL_CLASSIFICATION_SUCCESS});
						Modal.success({ title: `${langdata && langdata.ModelClassificationUpdatedSuccessfully ? langdata.ModelClassificationUpdatedSuccessfully :'Model Classification Updated Successfully'}` });
						editModelClassification.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadModelClassification();					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_MODEL_CLASSIFICATION_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const handleModalCancel = () => {
		setOpenEditDrawer(false);
		editModelClassification.resetForm();
		form.resetFields();

	};

	const showAddDrawer = () => {

		setOpenAddDrawer(true);
		loadpredicitonlevel();
	};

	const onCloseAddDrawer = () => {
		form.resetFields();
		addModelClassification.resetForm();
		setOpenAddDrawer(false);
	};

	const addModelClassification = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			modelLevel : '',
			pmodelLevel : '',
			description : '',
			loaderType : '',
			predictionlevelId : null
	
		},
		onSubmit: (values) => {
	
					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!values.modelLevel || values.modelLevel == null || values.modelLevel === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheModelLevel ? langdata.PleaseEnterTheModelLevel : 'Please enter the model level.' });
				return false;
			}
			if (!values.pmodelLevel || values.pmodelLevel == null || values.pmodelLevel === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheParentModelLevel ? langdata.PleaseEnterTheParentModelLevel : 'Please enter the parent model level.' });
				return false;
			}

			if (!values.predictionlevelId || values.predictionlevelId == null || values.predictionlevelId === undefined) {
				Modal.warning({ title: langdata && langdata.PleaseselectpredictionLevel ? langdata.PleaseselectpredictionLevel : 'Please select Prediction Level.' });
				return false;
			}
	
			dispatch({type:ADD_MODEL_CLASSIFICATION});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/modelclassifications`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					alias : values.name,
					modelLevel : values.modelLevel,
					parentmodelLevel : values.pmodelLevel,
					description : values.description,
					loaderType : values.loaderType,
					predictionlevelId : values.predictionlevelId
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_MODEL_CLASSIFICATION_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.AddModelClassificationSuccessfull ? langdata.AddModelClassificationSuccessfull :'Add Model Classification Successfull'}` });
						loadModelClassification();
						form.resetFields();
						addModelClassification.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: ADD_MODEL_CLASSIFICATION_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const loadModelClassificationDetails = ((record) => {
            
		dispatch( { type: MODEL_CLASSIFICATION_DETAILS });
                
		if (!record) {
			dispatch({ type: MODEL_CLASSIFICATION_DETAILS_ERROR });
		} else {
			dispatch({ type: MODEL_CLASSIFICATION_DETAILS_SUCCESS, payload: record });
            
		}
            
	});
	
	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 500 }}> 
			<p>{ langdata && langdata.ModelClassificationInfoContent ? langdata.ModelClassificationInfoContent  :  'The Model Classification module lists all available models in the system.'}</p>
			<br/>
			<div>
				<p><b>TF_CORE_LOADER:</b> tf.saved_model.load (Graph / Serving loader).</p>
				<p><b>KERAS_LOADER:</b> tf.keras.models.load_model (High-level Keras loader).</p>
				<p><b>KERAS_LEGACY_LOADER:</b> keras.models.load_model (Legacy alias).</p>
			</div>
		</Card>
	);

	return (

		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
				}}
				>

					<Col span={8}>
						<Row>
							<Space>
								<ProductOutlined  style={{fontSize:'30px'}}/>
								{/* <RedoOutlined style={{fontSize:'30px'}}/> */}
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							{/* <Col style={{marginLeft:'4px'}} span={19}> */}
							<Title level={4} style={{ paddingTop:'10px'}}> Model Classifications</Title>
						</Row>
					</Col>

					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.ModelClassification ? langdata.ModelClassification:'Model Classification'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
					
				</Row>

				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.modelClassificationDate.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.modelClassificationDate} 
							/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>

				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteModal} onOk={deleteModelClassification} onCancel={closeDeleteBatchModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisAssetType ? langdata.AreYouSureYouWantToDeleteThisAssetType : 'Are you sure you want to delete this asset type' }</Col>
					</Row>
				</Modal>

				<Modal
					title={langdata && langdata.EditModelClassification ? langdata.EditModelClassification:'Edit Model Classification'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editModelClassification.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editModelClassification.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editModelClassification.handleSubmit} layout="vertical"
						form={form} 
					// onValuesChange={handleUpdateFormValuesChange}
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<Input name="name" value={editModelClassification.values.name} onChange={editModelClassification.handleChange} defaultValue={editModelClassification.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="description" label={langdata && langdata.Description ? langdata.Description : 'Description'} rules={[{ required: true, message: langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the description' }]} >
									{/* <Input name="addTaskDescription" onChange={addTasklistFormik.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter Description'} /> */}
									<TextArea  name="description" rows={4} onChange={editModelClassification.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the  description'}
										defaultValue = {editModelClassification.values.description} />
								</Form.Item>
							</Col>
						</Row>	
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.loaderType ? langdata.loaderType:'Loader Type'} rules={[{ required: false, message: `${langdata && langdata.loaderType ? langdata.loaderType:'Loader Type'}` }]}>
									<Input name="loaderType" value={editModelClassification.values.loaderType} onChange={editModelClassification.handleChange} defaultValue={editModelClassification.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="predictionlevelId" label={ langdata&&langdata.PredictionLevel?langdata.PredictionLevel:'Prediction Level'} rules={[{ required: false, message: langdata && langdata.PleaseselectpredictionLevel ? langdata.PleaseselectpredictionLevel : 'Please select Prediction Level.'}]} >
									<Select name="predictionlevelId" onChange={(value) => editModelClassification.setFieldValue('predictionlevelId', value)} 
										placeholder={ langdata && langdata.PleaseselectpredictionLevel ? langdata.PleaseselectpredictionLevel : 'Please select Prediction Level.'} 
										options={predictionlevels}
										defaultValue={editModelClassification.values && editModelClassification.values.predictionlevelId} 
									/>
								</Form.Item>
							</Col>
						</Row>
				
									
					</Form>
				</Modal>

				<Modal
					title={ langdata&&langdata.AddModelClassification ? langdata.AddModelClassification : 'Add Model Classification' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addModelClassification.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addModelClassification.handleSubmit} form={form} >
                                                    
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name' }]} >
									<Input name="name" onChange={addModelClassification.handleChange} placeholder={langdata&&langdata.PleaseEnterName?langdata.PleaseEnterName:'Please Enter Name'} />
								</Form.Item>
							</Col>
						</Row>														
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="modelLevel" label={langdata&&langdata.ModelLevel?langdata.ModelLevel:'Model Level'} rules={[{ required: true, message: langdata && langdata.PleaseEnterTheModelLevel ? langdata.PleaseEnterTheModelLevel : 'Please enter the model level' }]} >
									<Input name="modelLevel" onChange={addModelClassification.handleChange} placeholder={langdata&&langdata.PleaseEnterTheModelLevel?langdata.PleaseEnterTheModelLevel:'Please enter the model level'} />
								</Form.Item>
							</Col>
						</Row>														
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="pmodelLevel" label={langdata&&langdata.ParentModelLevel?langdata.ParentModelLevel:'Parent Model Level'} rules={[{ required: true, message: langdata && langdata.PleaseEnterTheParentModelLevel ? langdata.PleaseEnterTheParentModelLevel : 'Please enter the parent model level' }]} >
									<Input name="pmodelLevel" onChange={addModelClassification.handleChange} placeholder={langdata&&langdata.PleaseEnterTheParentModelLevel?langdata.PleaseEnterTheParentModelLevel:'Please enter the parent model level'} />
								</Form.Item>
							</Col>
						</Row>	
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="description" label={langdata && langdata.Description ? langdata.Description : 'Description'} rules={[{ required: true, message: langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the description' }]} >
									{/* <Input name="addTaskDescription" onChange={addTasklistFormik.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter Description'} /> */}
									<TextArea  name="description" rows={4} onChange={addModelClassification.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the  description'}/>
								</Form.Item>
							</Col>
						</Row>		
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="loaderType" label={langdata&&langdata.loaderType?langdata.loaderType:'Loader Type'} rules={[{ required: true, message: langdata && langdata.PleaseEnterLoaderType ? langdata.PleaseEnterLoaderType : 'Please enter loader type' }]} >
									<Input name="loaderType" onChange={addModelClassification.handleChange} placeholder={langdata&&langdata.PleaseEnterLoaderType?langdata.PleaseEnterLoaderType:'Please enter loader type'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="predictionlevelId" label={ langdata&&langdata.PredictionLevel?langdata.PredictionLevel:'Prediction Level'} rules={[{ required: true, message: langdata && langdata.PleaseselectpredictionLevel ? langdata.PleaseselectpredictionLevel : 'Please select Prediction Level.'}]} >
									<Select name="predictionlevelId" onChange={(value) => addModelClassification.setFieldValue('predictionlevelId', value)} 
										placeholder={ langdata && langdata.PleaseselectpredictionLevel ? langdata.PleaseselectpredictionLevel : 'Please select Prediction Level.'} 
										options={predictionlevels}
									/>
								</Form.Item>
							</Col>
						</Row>												
					</Form>
				</Modal>
				
			</Content>
			

			<Spin fullscreen spinning={data.loading} />
      
			{/* Add Fiber Management Starts */}
		</>
	);
}